import type { CartItem } from "../contexts/cartContext";

const BASE_URL = process.env.REACT_APP_API_URL ?? "";

export interface OrderItem {
  id: string;
  name: string;
  image: string;
  size: string;
  quantity: number;
  price: number;
}

export interface OrderRecord {
  id: string;
  user_id: string;
  items: OrderItem[];
  total: number;
  created_at: string;
}

export const saveOrder = async (
  sessionId: string,
  items: CartItem[],
  total: number,
  accessToken: string
): Promise<OrderRecord> => {
  const orderItems: OrderItem[] = items.map((i) => ({
    id: i.variant.id,
    name: i.variant.name,
    image: i.variant.image ?? "",
    size: i.variant.size,
    quantity: i.quantity,
    price: i.variant.salePrice ?? 0,
  }));

  const res = await fetch(`${BASE_URL}/api/v1/orders`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ session_id: sessionId, items: orderItems, total }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail ?? "Failed to save order");
  }

  return res.json();
};

export const fetchOrders = async (
  accessToken: string
): Promise<OrderRecord[]> => {
  const res = await fetch(`${BASE_URL}/api/v1/orders`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!res.ok) throw new Error("Failed to fetch orders");
  return res.json();
};
